import apiService from './api';

export interface SiteSettings {
  siteUrl: string;
  siteName: string;
  emailFromAddress: string;
  emailFromName: string;
}

class SettingsApiService {
  async getSiteSettings(): Promise<SiteSettings> {
    try {
      const res = await apiService.get('/api/admin/settings/site');
      return res.data as SiteSettings;
    } catch (err: any) {
      if (err?.response?.status === 404) {
        // Try fallback under email module
        try {
          const res = await apiService.get('/api/admin/email/site-settings');
          return res.data as SiteSettings;
        } catch (err2: any) {
          if (err2?.response?.status === 404) {
            // As a last resort, provide defaults so UI remains usable (read-only)
            const defaults: SiteSettings = {
              siteUrl: (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:18000'),
              siteName: 'ThreatCompass',
              emailFromAddress: 'alerts@threatcompass.net',
              emailFromName: 'ThreatCompass',
            };
            // attach a non-enumerable flag to indicate read-only fallback
            Object.defineProperty(defaults, '__readonly', { value: true, enumerable: false });
            return defaults as SiteSettings;
          }
          throw err2;
        }
      }
      throw err;
    }
  }

  async updateSiteSettings(payload: Partial<SiteSettings>): Promise<SiteSettings> {
    try {
      const res = await apiService.put('/api/admin/settings/site', payload);
      return res.data as SiteSettings;
    } catch (err: any) {
      if (err?.response?.status === 404) {
        // Try fallback endpoint
        const res = await apiService.put('/api/admin/email/site-settings', payload);
        return res.data as SiteSettings;
      }
      throw err;
    }
  }
}

export const settingsApi = new SettingsApiService();
export default settingsApi;
